import { ElementNotFound } from "@senciamatch/frontend/components/ElementNotFound";
import { LoadingData } from "@senciamatch/frontend/components/LoadingData";
import { trpc } from "@senciamatch/frontend/libs/trpc";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const HighPrioritiesPage: React.FC = () => {
  const getBuildingHighPriorityStaffs = trpc.getBuildingHighPriorityStaffs.useQuery();
  const deleteBuildingHighPriorityStaff = trpc.deleteBuildingHighPriorityStaff.useMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (deleteBuildingHighPriorityStaff.isSuccess) {
      getBuildingHighPriorityStaffs.refetch();
    }
  }, [deleteBuildingHighPriorityStaff.isSuccess, getBuildingHighPriorityStaffs.refetch]);

  if (getBuildingHighPriorityStaffs.isPending || !getBuildingHighPriorityStaffs.data) return <LoadingData />;
  if (!getBuildingHighPriorityStaffs.data) return <ElementNotFound />;

  return (
    <div className="h-screen flex flex-col">
      <h2 className="text-2xl font-bold py-10 flex-shrink-0">優先マッチング条件一覧</h2>
      <div className="overflow-x-auto py-10 bg-white border border-base-100 px-8 flex-grow flex flex-col">
        <div className="flex justify-between pb-8 flex-shrink-0">
          <button
            type="button"
            className="bg-primary-700 text-white px-4 py-2 rounded-md"
            onClick={() => navigate("/high-priorities/new")}
          >
            新規登録
          </button>
        </div>
        <div className="overflow-y-auto flex-grow">
          <table className="min-w-full">
            <thead className="sticky top-0 bg-gray-100">
              <tr className="bg-gray-100">
                <th className="p-2 text-left border border-gray-200">従業員名</th>
                <th className="p-2 text-left border border-gray-200">物件番号</th>
                <th className="p-2 text-left border border-gray-200">物件名</th>
                <th className="p-2 text-left border border-gray-200">会社名</th>
                <th className="p-2 text-left border border-gray-200" />
              </tr>
            </thead>
            <tbody>
              {(getBuildingHighPriorityStaffs.data?.buildingHighPriorityStaffs || []).map(
                (buildingHighPriorityStaff) => (
                  <tr key={buildingHighPriorityStaff.id}>
                    <td className="p-2 text-left border border-gray-200">{buildingHighPriorityStaff.staffName}</td>
                    <td className="p-2 text-left border border-gray-200">{buildingHighPriorityStaff.buildingNumber}</td>
                    <td className="p-2 text-left border border-gray-200">{buildingHighPriorityStaff.buildingName}</td>
                    <td className="p-2 text-left border border-gray-200">{buildingHighPriorityStaff.companyName}</td>
                    <td className="p-2 text-left border border-gray-200">
                      <button
                        type="button"
                        className="text-primary-700"
                        onClick={() => {
                          deleteBuildingHighPriorityStaff.mutate({ id: buildingHighPriorityStaff.id });
                        }}
                      >
                        削除
                      </button>
                    </td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
